<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='入科管理' label2="报告通知单预览" label3="Tips：打印时需选择横向打印，并去掉页眉页脚" url="/cycle/entry/list"></PageHead>
      <div class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
        <div class="m-portlet__body" style="margin-top: 30px;">
          <div class="row" style="padding: 0 50px 50px 0;">
            <div class="col-lg-12 m--align-right">
              <el-button type="primary" @click="Print">打印</el-button>
            </div>
          </div>
          <!--startprint-->
          <div id="printDiv" style="margin: 0 auto;" v-html="tableData">
            <!--endprint-->
          </div>
        </div>
        <!-- <div style="width: 150px;height: 90px;text-align: right;position:relative;">
          <p style="position: absolute;right: 0;bottom: 0;">无锡市人民医院教育处<br>2020年7月3号</p>
          <div style="width: 90px;height: 90px;position:absolute;">
            <img src="../../../assets/image/wxrmjyc.png" style="width: 90px;" />
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NoticePrint',
    data() {
      return {
        condition: {
          token: '',
          truename: '',
          noticedate: '',
          realname: '',
          section: '',
          cardno: '',
          specialty: '',
          entrydate: '',
          outdate: '',
          secretarysec: ''
        },
        tableData: '',
        loading: null
      }
    },
    methods: {
      Print: function() {
        var iframe = document.getElementById("print-iframe");
        if (iframe) {
          document.body.removeChild(iframe);
        }
        var el = document.getElementById("printDiv");
        iframe = document.createElement('IFRAME');
        var doc = null;
        iframe.setAttribute("id", "print-iframe");
        iframe.setAttribute('style', 'position:absolute;width:0px;height:0px;left:-500px;top:-500px;');
        document.body.appendChild(iframe);
        doc = iframe.contentWindow.document;
        doc.write(el.innerHTML);
        doc.close();
        iframe.contentWindow.focus();
        iframe.onload = function() {
          iframe.contentWindow.print();
        };
      },
      DownLoad: function() {

      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.condition.username = sessionStorage.getItem('username')
      this.condition.rolelevel = sessionStorage.getItem('rolelevel')
      this.condition.truename = this.$route.params.truename
      this.condition.noticedate = this.$route.params.noticedate
      this.condition.realname = this.$route.params.realname
      this.condition.section = this.$route.params.section
      this.condition.cardno = this.$route.params.cardno
      this.condition.specialty = this.$route.params.specialty
      this.condition.entrydate = this.$route.params.entrydate
      this.condition.outdate = this.$route.params.outdate
      this.condition.secretarysec = this.$route.params.secretarysec

      this.loading = this.$loading({
        lock: true,
        background: 'rgba(0, 0, 0, 0.7)'
      });
      var that = this
      this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/NoticePrint', this.condition)
        .then(res => {
          if (res.data.Code === 0) {
            this.tableData = res.data.Data
          } else {
            this.$message({
              message: res.data.Msg + '，' + res.data.Error,
              type: 'error'
            })
          }
          that.loading.close()
        })
        .catch(err => {
          this.tableData = ''
          console.log(err)
          this.$message({
            message: '查询失败',
            type: 'error'
          })
          that.loading.close()
        })
    }
  }
</script>

<style>
</style>
